import * as constants from '../constants';
// ui actions

export const toggleSection = (section: number, expanded: boolean) => ({
  type: constants.TOGGLE_ITEM,
  payload: { section, expanded }
});

export const toggleTabs = (show: boolean) => ({
  type: constants.TOGGLE_TABS,
  payload: { show }
});

export const selectTab = (tab: string) => ({
  type: constants.SET_ACTIVE_TAB,
  payload: { tab }
});

// contact form

export const setFormData = (data: { name: string; email: string; message: string }) => ({
  type: constants.SET_FORM_DATA,
  payload: {
    data
  }
});

export const submitForm = (
  data: {
    name: string;
    email: string;
    message: string;
  },
  language: string,
  country: string
) => {
  return {
    type: constants.SUBMIT_FORM,
    payload: { data, language, country }
  };
};

export const setFormLoading = (loading: boolean) => ({
  type: constants.SET_FORM_LOADING,
  payload: { loading }
});

export const setSubmitSuccess = (success: boolean) => ({
  type: constants.SET_SUBMIT_SUCCESS,
  payload: { success }
});

export const setSubmitFail = (fail: boolean) => ({
  type: constants.SET_SUBMIT_FAIL,
  payload: { fail }
});

export const setFormErrors = (errors: { [key: string]: boolean }) => ({
  type: constants.SET_FORM_ERRORS,
  payload: { errors }
});

// legal entities

// --- types ---
export interface FetchLegalEntitiesAction {
  type: typeof constants.FETCH_LEGAL_ENTITIES;
  payload: { country: string };
}

export interface FetchLegalEntitiesSuccessAction {
  type: typeof constants.FETCH_LEGAL_ENTITIES_SUCCESS;
  payload: any; // ideally replace `any` with API response type
}

export interface FetchLegalEntitiesFailureAction {
  type: typeof constants.FETCH_LEGAL_ENTITIES_FAILURE;
  payload: string; // error message
}

export type LegalEntitiesActionTypes =
  | FetchLegalEntitiesAction
  | FetchLegalEntitiesSuccessAction
  | FetchLegalEntitiesFailureAction;

// --- action creators ---
export const fetchLegalEntities = (country: string): FetchLegalEntitiesAction => ({
  type: constants.FETCH_LEGAL_ENTITIES,
  payload: { country }
});

export const fetchLegalEntitiesSuccess = (data: any): FetchLegalEntitiesSuccessAction => ({
  type: constants.FETCH_LEGAL_ENTITIES_SUCCESS,
  payload: data
});

export const fetchLegalEntitiesFailure = (error: string): FetchLegalEntitiesFailureAction => ({
  type: constants.FETCH_LEGAL_ENTITIES_FAILURE,
  payload: error
});

// market content
export const setMarketContent = (content: any) => ({
  type: constants.SET_MARKET_CONTENT,
  payload: { content }
});
